import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { errMsg } from "./utils";

export const LeadEditDialog = ({ projectId, lead, onClose, onSaved }) => {
  const [f, setF] = useState({ company_phone: "", why_fit: "", products: "" });
  useEffect(() => {
    if (lead) setF({ company_phone: lead.company_phone || "", why_fit: lead.why_fit || "", products: lead.products || "" });
  }, [lead]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async () => {
    try {
      await api.patch(`/agency/projects/${projectId}/leads/${lead.lead_id}`, f);
      toast.success("Αποθηκεύτηκε");
      onSaved({ ...lead, ...f });
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <Dialog open={!!lead} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="agency-lead-edit-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit']">{lead?.company_name} — {lead?.first_name} {lead?.last_name}</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="space-y-1.5">
            <Label>Τηλέφωνο εταιρείας</Label>
            <Input value={f.company_phone} onChange={set("company_phone")} data-testid="lead-edit-phone-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Προϊόντα που εμπορεύεται</Label>
            <Textarea rows={2} value={f.products} onChange={set("products")} data-testid="lead-edit-products-input" />
          </div>
          <div className="space-y-1.5">
            <Label>Γιατί ταιριάζει</Label>
            <Textarea rows={5} value={f.why_fit} onChange={set("why_fit")} data-testid="lead-edit-whyfit-input" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={save} data-testid="lead-edit-save-btn">Αποθήκευση</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
